import SimpleLightbox from "simplelightbox";

let gallery = new SimpleLightbox('.gallery a');

gallery.on('show.simplelightbox', function () {});
